// biome-ignore format: historic
// biome-ignore format: historic
// biome-ignore format: historic
import { LockableTextField } from '@components/Card2/LockableTextField';
import { useCardPopoverInputFocus } from '@hooks/card';
import useOnFocus from '@hooks/use-on-focus';
import useValidateInput, { emailValidator } from '@hooks/use-validate-input';
import { getSuggestionsByFieldType } from '@modules/card-helpers';
import { Stack } from '@ui-lib';

import { LabelField } from '../LabelField';

interface EmailFieldsProps {
  value: string;
  valueLocked: boolean;
  valueLockEnabled?: boolean;
  label: string;
  labelLocked: boolean;
  labelLockEnabled?: boolean;
  labelLockedByTemplate?: boolean;
  setValue: (value: string) => void;
  setValueLocked: (value: boolean) => void;
  setLabel: (value: string) => void;
  setLabelLocked: (value: boolean) => void;
}

function EmailFields({
  label,
  value,
  setValueLocked,
  valueLocked,
  valueLockEnabled,
  setLabel,
  setValue,
  setLabelLocked,
  labelLocked,
  labelLockEnabled,
  labelLockedByTemplate,
}: EmailFieldsProps): React.ReactElement {
  const [isError, errorMessage] = useValidateInput(value, [emailValidator]);
  const { inputRef, inputNode } = useCardPopoverInputFocus();
  const [, , emailInputBlurred] = useOnFocus(inputNode);
  const options = getSuggestionsByFieldType('email')();

  return (
    <Stack gap="large">
      <LockableTextField
        value={value}
        onChange={(event) => setValue(event.currentTarget.value)}
        label="Value"
        type="email"
        autoComplete="email"
        message={isError && emailInputBlurred ? errorMessage : undefined}
        tone={isError && emailInputBlurred ? 'critical' : 'neutral'}
        ref={inputRef}
        required
        locked={valueLocked}
        toggleLocked={valueLockEnabled ? () => setValueLocked(!valueLocked) : undefined}
      />
      <LabelField
        label={label}
        labelLocked={labelLocked}
        labelSuggestions={options}
        setLabel={setLabel}
        setLabelLocked={labelLockEnabled ? setLabelLocked : undefined}
        labelLockedByTemplate={labelLockedByTemplate}
      />
    </Stack>
  );
}

export default EmailFields;
